<template>
  <div>
    <v-card
      class="mx-auto fixed-header"
    >
      <v-app-bar
        dark
        class="fixed-header"
        style="background-color: #ffffff;color:black"
      >
        <!--      <v-app-bar-nav-icon></v-app-bar-nav-icon>-->
        <div style="margin-left: 25px;" >
          <img :src="get_user_image()" class="circle-img"/>
        </div>
        <v-toolbar-title>
        <span class="router-name">
          {{$route.meta.name}}
        </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn style="left:0;position: absolute" v-on:click="$router.go(-1)" v-if='$route.meta.name != "خانه"' icon>
          <v-icon color="black" >mdi-chevron-left</v-icon>
        </v-btn>
      </v-app-bar>

    </v-card>
    <br>
    <v-tabs
      v-model="tab"
class="home-tabs"

      align-with-title
    >
<!--      <v-tabs-slider color="yellow"></v-tabs-slider>-->
      <v-tab href="#home-tab" to="/home-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_request_blue.svg" />
        <p class="home-tabs-title">ثبت درخواست</p>
        </div>
      </v-tab>
      <v-tab href="#profile-tab" to="/report-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_report_grey.svg" />
          <p class="home-tabs-title">گزارش درخواست</p>
        </div>
      </v-tab>
      <v-tab href="#message-tab" to="/message-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_messenger_grey.svg" />
          <p class="home-tabs-title">پیام رسان</p>
        </div>
      </v-tab>
      <v-tab href="#profile-tab" to="/profile-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_account_grey.svg" />
          <p class="home-tabs-title">پروفایل</p>
        </div>
      </v-tab>
      <v-tabs-items>
        <v-card flat>
          <v-card-text style="margin-top:30px " >
<!--            <div class="row requests" v-if="$i18n.locale=='fa'">-->

<!--              <div class="col-6">-->
<!--                <span v-on:click="go_to_customer_info(false)">-->
<!--                  <img src="../../../public/img/add_request.png" />-->
<!--                </span>-->
<!--              </div>-->
<!--              <div class="col-6">-->
<!--                <span v-on:click="go_to_add_question(true)">-->
<!--                  <img src="../../../public/img/create_question.png" />-->
<!--                </span>-->
<!--              </div>-->

<!--            </div>-->
<!--            <div class="row requests" v-if="$i18n.locale=='en'">-->

<!--              <div class="col-6">-->
<!--                <span v-on:click="go_to_customer_info(false)">-->
<!--                  <img src="../../../public/img/add_request_tr.png" />-->
<!--                </span>-->
<!--              </div>-->
<!--              <div class="col-6">-->
<!--                <span v-on:click="go_to_add_question(true)">-->
<!--                  <img src="../../../public/img/create_question_tr.png" />-->
<!--                </span>-->
<!--              </div>-->

<!--            </div>-->
          </v-card-text>
        </v-card>
      </v-tabs-items>
    </v-tabs>
  </div>

</template>
<script>
  import { bus } from '../../main.js'
  export default {
    data () {
      return {
        tab: null,
        accept_device: false,
        app_version:process.env.VUE_APP_VERSION_CODE,

      }
    },
    components:{
    },
mounted () {
      this.check_user_in_zoodkomak()
      this.technician_login()
  Notification.requestPermission(permission => {
    if (permission === 'granted'){ registerBackgroundSync() }
    else console.error("Permission was not granted.")
  })
  // const not=new Notification("hellow",{
  //   body:"this is text",
  //
  // });
      },
    methods:{
      technician_login () {
        var self = this
        var eddited_mobile = localStorage.getItem('zoodpayam_phone')
        var password = localStorage.getItem('zoodpayam_password')

        const send_data = {
          Phone: eddited_mobile,
          Password: password,
          OsName: 'ZoodPayam',
          AppNo: '7',
          OsVersion: '7',
          DeviceModel: 'android',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/Activate', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('version is ', self.app_version, response.data.newVersion.VersionCode)
              if (self.app_version < response.data.newVersion.VersionCode) {
               console.log("must reload");
                // window.location.reload()
                if ('serviceWorker' in navigator) {
                  caches.keys().then(function(cacheNames) {
                    cacheNames.forEach(function(cacheName) {
                      caches.delete(cacheName);
                    });
                  });
                }
                window.location.reload(true)
              }
            } else {
              localStorage.setItem('zoodpayam_profile', '')
              localStorage.setItem('zoodpayam_phone', '')
              localStorage.setItem('zoodpayam_password', '')
              localStorage.setItem('party_id', '')
              self.$router.push({ name:'login', params:{} })

              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          // this.errors.push(e);
          // bus.$emit('show_toast', [2000, e])

        })
      },

      check_user_in_zoodkomak () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var user_name = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserName

        const send_data = {
          MobileNo: localStorage.getItem('zoodpayam_phone').replace('+98', ''),
          Pass: localStorage.getItem('zoodpayam_password'),
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, { show_pros:false })
          .then(response => {
            localStorage.setItem('userId2', response.data.UserId)
            const send_data = {
              UserName: user_name,
              UserId: response.data.UserId,
              MobileNo: localStorage.getItem('zoodpayam_phone'),
              Password: localStorage.getItem('zoodpayam_password'),
            }
            var formData = new FormData();
            formData.append("UserName",user_name)
            formData.append("UserId",response.data.UserId)
            formData.append("MobileNo",localStorage.getItem('zoodpayam_phone'))
            formData.append("Password",localStorage.getItem('zoodpayam_password'))
            // this.axios.post('/Register' , send_data,{
            self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, { show_pros:false })
              .then(response => {
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              // this.errors.push(e)
            })
          }).catch(e => {
          // this.errors.push(e)
        })
      },

      go_to_customer_info (OnSite) {
        var PassingData = { on_site_service:OnSite }
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        // this.$store.commit('set', ['request_data', PassingData])
        // this.$store.commit('toggleSidebarDesktop')
        // console.log(store.state.count) //
        this.$router.push({ name:'Categories', params:{} })

        // this.$router.push({name:'CustomerInfo', params:{}})
      },
go_to_referred_requests () {
        this.$router.push({ name:'ReferredRequest', params:{} })
      },
      go_to_add_question () {
        this.$router.push({ name:'AddQuestion', params:{} })
      },
      go_to_safir_devices () {
        this.$router.push({ name:'SafirDevices', params:{} })
      },

    }
  }
</script>
